import Adicionar from './Adicionar';
import Default from './Default';
import Editar from './Editar';

export default Default;

export const EmpresasAdicionar = Adicionar;
export const EmpresasEditar = Editar;
